<template>
  <v-card>
    <v-card-title class="card-title">
      <v-layout>
        <v-flex shrink align-self-center>
        </v-flex>
        <v-flex grow class="headline blue--darken1-text">
          {{ event.name }}
        </v-flex>
      </v-layout>
    </v-card-title>
    <v-divider />
    <v-card-text>
      <v-layout
        align-content-center
      >
        <v-flex
          shrink
          align-self-center
        >
          <v-icon color="info">
            place
          </v-icon>
        </v-flex>
        <v-flex>
          <address>
            <span class="addr-name">{{ rink.name }}</span>
            <span class="addr-street">{{ rink.address }}</span>
            <span class="addr-area">{{ rink.city }} {{ rink.state }}, {{rink.zip }}</span>
          </address>
        </v-flex>
      </v-layout>
      <v-divider />
      <v-card-actions>
        <v-layout>
          <v-flex align-self-center shrink>
            <v-icon color="info" class="ma-2">
              event
            </v-icon>
          </v-flex>
          <v-flex align-self-center >
            <small v-show="hasSessions"><em>{{ hasSessions ? 'Event begins ' : '' }}<br></em></small>
            {{ eventDatetime }}
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex align-self-center >
            <v-btn
              icon
              flat
              v-show="hasSessions"
              @click="showSchedule = !showSchedule"
            >
              <v-icon>
                {{ showSchedule ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}
              </v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-actions>
      <v-slide-y-transition>
        <v-card-text v-show="showSchedule">
          <v-flex xs12><h5>Schedule</h5></v-flex>
          <v-layout row wrap v-for="session in event.sessions" :key="session.id">
            <v-flex xs3>
              {{ viewDate(session.date, true) }}
            </v-flex>
            <v-flex xs3>
              {{ viewTime(session.start) }}
            </v-flex>
            <v-flex xs3>
              {{ viewTime(session.end) }}
            </v-flex>
            <v-flex xs12>
              {{ session.notes }}
            </v-flex>
            <v-divider/>
          </v-layout>
        </v-card-text>
      </v-slide-y-transition>
      <v-divider />
      <v-layout wrap justify-center>
        <v-flex xs10>
          <v-alert
            :value="waitlist"
            type="warning"
          >
            {{ $t('eventCard.waitlist') }}
          </v-alert>
        </v-flex>
        <v-flex xs10>
          <v-alert
            :value="soldout"
            type="error"
          >
            {{ $t('eventCard.soldout') }}
          </v-alert>
        </v-flex>
        <v-flex xs10>
          <v-alert
            :value="!!promote"
            type="info"
          >
            {{ $t('eventCard.promote') }} {{ $t('eventCard.promoteDate') }} {{ promote }}
          </v-alert>
        </v-flex>
      </v-layout>
      <v-layout wrap>
        <v-flex v-show="!isAdult" shrink align-self-center>
          <v-icon color="warning" class="pl-2 ma-2">
            warning
          </v-icon>
        </v-flex>
        <v-flex v-show="!isAdult" xs10 align-self-center class="pa-2">
          <em>{{ ageRestriction }}</em>
        </v-flex>
        <v-flex xs12 class="pa-2">
          <!-- Event Status -->
        </v-flex>
        <v-flex align-self-end shrink class="pl-5" style="border-bottom: 2px dotted #eee;">
          <b>{{$t('eventCard.registration') }}</b>
        </v-flex>
        <v-spacer style="border-bottom: 2px dotted #eee;" />
        <v-flex align-self-end shrink class="text-xs-right pr-5" style="border-bottom: 2px dotted #eee;">
          <b>${{ parseFloat(event.fee).toFixed(2) }}</b>
        </v-flex>
      </v-layout>
    </v-card-text>
    <v-card-actions class="card-actions">
      <v-btn
        flat
        color="white"
        @click="$router.push('/event/'+event.id+'/detail')"
      >
        <v-icon>
          search
        </v-icon>
        {{ $t('eventCard.moreInfoBtn') }}
      </v-btn>
      <v-btn
        flat
        color="white"
        @click="$router.push('/registration/'+event.id+'/0')"
        v-show="!soldout"
      >
        {{ $t('eventCard.registerBtn') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import * as date from '../libs/js/dates'

export default {
  name: 'EventCard',
  data(){
    return {
      showSchedule: false
    }
  },
  props: {
    event: Object,
  },
  computed: {
    rink () {
      if(this.event['location-id']) return this.$store.state.rinks.find(r => r.id === this.event['location-id'])
      else return {}
    },
    hasRink () {
      return (this.event['location-id'] == true) && (this.$store.state.rinks.find(r => r.id === this.event['location-id']) == true)
    },
    hasSessions () {
      return Array.isArray(this.event.sessions) && this.event.sessions.length > 0
    },
    bdateMin () {
      if(this.isAdult) return false
      return date.viewDate(this.event['bdate-min'] || this.event['nhl-bdate-min'], this.$i18n.locale)
    },
    bdateMax () {
      if(this.isAdult) return false
      return date.viewDate(this.event['bdate-max'] || this.event['nhl-bdate-max'], this.$i18n.locale)
    },
    ageRestriction () {
      return this.$t('eventCard.bdateRestriction').replace('%1', this.bdateMin).replace('%2', this.bdateMax)
    },
    eventDatetime () {
      return date.viewDatetime(this.event['event-datetime'], this.$i18n.locale, this.rink.time_zone)
    },
    viewDate () {
      return (val, short) => date.viewDate(val, this.$i18n.locale, short)
    },
    viewDatetime () {
      return (val) => date.viewDatetime(val, this.$i18n.locale, this.rink.time_zone)
    },
    viewTime () {
      return (val) => date.viewTime(val, this.$i18n.locale, this.rink.time_zone)
    },
    waitlist () {
      if (this.soldout) return false
      if (this.event.id) {
        return this.event.status == 'active-waitlist' || this.event['open-spaces'] < 1
      } else {
        return false
      }
    },
    soldout () {
      if (this.event.id) {
        if (this.event.status == 'soldout') {
          return true
        }
        if ((this.event.status.indexOf('promo') !== -1) &&
          (this.event['open-spaces'] < 1) &&
          (this.$store.state.team.use_waitlist == 0)) {
            return true
        }
        return false
      } else {
        return false
      }
    },
    promote () {
      if (this.event.id) {
        if (this.event.status.indexOf('presale') !== -1) {
          return this.viewDate(this.event['registration-open'], false)
        } else {
          return false
        }
      } else {
        return false
      }
    },
    isAdult () {
      return this.$store.state.team.is_adult_registration === 1
    }
  }
}
</script>

<style scoped>
address {
  font-style: normal;
}
address span {
  display: block;
}

.card-title {
  background-color: #c8102e;
  color: rgba(255,2555,255,.9);
}

.card-actions {
  background-color: #041e42;
  color: rgba(255, 255, 255, 0.8);
  justify-content: end;
}
</style>